import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Panel } from 'rsuite';
import { ContentContainer, LoadingSpinerArea, NotificationMessage } from '../../../../../components';
import { MainContainer } from '../../components';
import { NewPriceTableDefine, NewPriceTableForm, GeneralRules, PriceLimits, TablePanelHeader, ProductDetailTable } from './components';
import { useCreateComercialTableStore } from './CreateComercialTable.store';
import { useProductDetailingList } from './hooks/useProductDetailingList';
import * as service from './services';
import styles from './CreateComercialTable.module.scss';
import { useManageComercialTableStore } from '../ManageComercialTable/ManageComercialTable.store';
import { useConsultComercialTable } from '../ManageComercialTable/hooks/useConsultComercialTable';
import { useComercialProductDetailingList } from '../ManageComercialTable/hooks/useComercialProductDetailingList';
import { CreateComercialTableType, EditComercialTableType } from './types';

export const CreateComercialTable = () => {
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const match = location?.pathname?.match(/\d+$/);
  const urlID = match ? parseInt(match[0], 10) : undefined;

  const { createComercialTableBody, isCreateComercialTable, productDetailingList, reset, setCreateComercialTableState } = useCreateComercialTableStore();

  const { setConsultComercialTableID } = useConsultComercialTable();

  const { handleGetComercialEditData } = useComercialProductDetailingList();

  const productDetailing = useProductDetailingList();

  const canCreateTable =
    createComercialTableBody.produtosBase?.length &&
    createComercialTableBody.local !== '' &&
    createComercialTableBody.canal !== '' &&
    createComercialTableBody.subCanal !== '' &&
    createComercialTableBody.regras[0].percentualIdeal > 0;

  const editComercialTable = async () => {
    const newObj = {
      ...createComercialTableBody,
      idTabelaComercial: urlID,
    };
    delete newObj.idTabelaBase;
    const res = await service.saveEditTabelaComercial(newObj);
    if (res.status === 200) {
      NotificationMessage('success', 5000, 'Tabela editada com sucesso');
      history.push('/ipa/gerenciar-tabela-comercial');
    }
  };

  const createComercialTable = async () => {
    const res = await service.createSaveTabelaComercial(createComercialTableBody);
    if (res.status === 200) {
      NotificationMessage('success', 5000, 'Tabela criada com sucesso');
      history.push('/ipa/gerenciar-tabela-comercial');
    }
  };

  const handleSaveTabelaComercial = (id: number) => {
    const urlHasID = id !== undefined && id !== null;
    if (canCreateTable) {
      urlHasID ? editComercialTable() : createComercialTable();
    } else {
      NotificationMessage('error', 5000, 'Verifique se os campos obrigatórios estão preenchidos');
    }
  };

  const handleChangeRules = (name: string, id: number, value: number) => {
    const productList = productDetailingList.content.map(item => (item.id === id ? { ...item, [name]: value } : item));

    const bodyList = createComercialTableBody.produtosBase.map(item => (item.idProduto === id ? { ...item, [name]: value } : item));

    setCreateComercialTableState('createComercialTableBody', {
      ...createComercialTableBody,
      produtosBase: bodyList,
    });
    setCreateComercialTableState('productDetailingList', {
      ...productDetailingList,
      content: productList,
    });
  };

  useEffect(() => {
    return () => {
      reset();
    };
  }, [reset]);

  useEffect(() => {
    if (urlID) {
      setConsultComercialTableID(urlID);
      handleGetComercialEditData(urlID);
    }
  }, [location?.pathname]);

  return (
    <MainContainer>
      {createComercialTableBody.nome === '' && !isCreateComercialTable && <LoadingSpinerArea />}
      <LoadingSpinerArea area="save-tabela-comercial" />
      <NewPriceTableForm />
      <NewPriceTableDefine onCloseProduct={productDetailing.refetchProductDetailing} />
      <GeneralRules onBlur={productDetailing.refetchProductDetailing} />
      <PriceLimits />
      <Panel
        header={<TablePanelHeader title="Detalhamento por produto" subtitle="Defina regras específicas por produto" status={isOpen} />}
        collapsible
        className={styles['panel-table']}
        onClick={() => setIsOpen(!isOpen)}
      >
        <ProductDetailTable hasOpen={isOpen} productDetailing={productDetailing} tableData={productDetailingList} onChangeRules={handleChangeRules} />
      </Panel>
      <ContentContainer className={styles['save-wrapper']}>
        <Button className={styles['btn-save']} appearance="primary" onClick={() => handleSaveTabelaComercial(urlID)}>
          Salvar tabela
        </Button>
      </ContentContainer>
    </MainContainer>
  );
};
